var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItrvlLogoAllWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 134,
    height: 58,
    viewBox: "0 0 134 58",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9234_44116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.0864 15.5359C66.2931 15.5359 65.6477 16.1926 65.6477 16.9999C65.6477 17.8066 66.279 18.4393 67.0864 18.4393C67.8938 18.4393 68.5511 17.7932 68.5511 16.9999C68.5511 16.1925 67.8938 15.5359 67.0864 15.5359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0345 38.0185H68.2867V21.0115H65.9131V35.8971C65.9131 37.0667 66.8649 38.0186 68.0345 38.0186V38.0185Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4442 35.9075C85.9679 36.0477 85.3606 36.1217 84.687 36.1217C83.5224 36.1217 82.5966 35.7342 82.0097 35.0007C81.6455 34.5457 81.308 33.9038 81.308 32.3017V23.2743H86.168V21.0113H81.308V16.4627H81.1664C79.9355 16.4627 78.9337 17.4639 78.9337 18.6947V21.0113H76.3614C75.1911 21.0113 74.24 21.9631 74.24 23.1327V23.2743H78.9337V32.2283C78.9337 34.1208 79.2937 35.4151 80.1018 36.4239C81.4581 38.1303 83.5569 38.3853 84.687 38.3853C85.3366 38.3853 86.3032 38.2819 86.8958 38.0846L87.0134 38.0451L86.5942 35.8631L86.4442 35.9075Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.294 20.6444C100.472 20.6444 98.6722 21.361 97.4801 22.5608L97.1532 22.8898V21.0115H96.6853C95.6349 21.0115 94.7803 21.8661 94.7803 22.9173V36.0817C94.7803 37.1498 95.6483 38.0186 96.7164 38.0186H97.1532V26.4985L97.168 26.4626C98.0607 24.3362 100.105 22.9074 102.257 22.9074C102.731 22.9074 103.093 22.9208 103.224 22.9419L103.366 22.9659L103.701 20.7416L103.563 20.7191C103.321 20.6789 102.563 20.6444 102.294 20.6444V20.6444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.294 34.1654L111.69 22.0225C111.406 21.4082 110.785 21.0115 110.108 21.0115H108.637L116.543 38.0186H118.08L125.95 21.0115H124.478C123.802 21.0115 123.182 21.4074 122.899 22.0211L117.294 34.1654Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.403 11.6945C132.172 11.6945 131.171 12.6957 131.171 13.9265V38.0178H131.844C132.782 38.0178 133.545 37.2547 133.545 36.317V11.6945H133.403Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1236 13.8707H29.1447V13.4374V12.1023V0.0206909L26.2195 12.3566C19.3001 13.5825 13.8476 19.1076 12.7295 26.0636L14.6113 25.6162C16.038 18.9138 22.0027 13.8707 29.1236 13.8707H29.1236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2914 28.9365H14.0632H12.523H0.646484L12.814 31.8217C14.1231 38.6924 19.6784 44.0758 26.6358 45.1263L26.1898 43.2529C19.4825 41.9009 14.3992 36.0116 14.2914 28.9365V28.9365Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5342 43.5396L29.5624 43.5509V44.0201V45.308V57.4375L32.52 44.9642C39.171 43.5776 44.3734 38.1991 45.502 31.458L43.6146 31.9068C42.1759 38.4274 36.4366 43.3514 29.5342 43.5396H29.5342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.083 12.3663L32.5346 14.2664C39.0263 15.7982 43.8842 21.6057 43.9617 28.5399L43.9694 28.5216H44.6465H45.7301H57.856H58.0639L45.4243 25.5244C44.1216 18.8411 38.7981 13.5781 32.083 12.3663L32.083 12.3663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.9313,
    cy: 22.7187,
    r: 2.3046,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9442 26.5054C27.7274 27.7214 26.3416 28.9057 26.3416 30.7735C26.3416 32.9808 27.9655 34.0018 28.9463 37.8436L28.9456 37.9275L28.9568 37.8852L28.9681 37.9275V37.8436C29.9481 34.0018 31.5728 32.9808 31.5728 30.7735C31.5728 28.9057 30.187 27.7214 28.9695 26.5054",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9234_44116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 132.897,
    height: 57.4165,
    fill: "white",
    transform: "translate(0.646484 0.0206299)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItrvlLogoAllWhite);
export default __webpack_public_path__ + "static/media/itrvl_logo--all-white.d71c2a4e85757214da4ee1c0d627ae2f.svg";
export { ForwardRef as ReactComponent };